import { Component } from 'react';

import { Button } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { reloadCurrentLocation } from '../../../iwRouter/LocationHelper';
import { WarningTriangleSVG } from '../../../svgComponents/warningTriangleSVG';
import { TrackErrorModalOpened } from '../../../tracking/amplitude.helpers';

class FallbackErrorModal extends Component {
    componentDidMount() {
        TrackErrorModalOpened();
    }

    render() {
        return (
            <div
                data-testid="fallback-error-modal"
                className="p-2xl text-center"
            >
                <WarningTriangleSVG className="mx-auto my-l text-5xl" />
                <div className="my-s text-l font-bold text-primary-10">
                    <FormattedMessage
                        id="_.modal.fallback_error.label"
                        defaultMessage="Oops, it looks like something went wrong"
                    />
                </div>
                <Button
                    className="mt-xl"
                    onClick={() => reloadCurrentLocation()}
                    variant="primary-rounded"
                    size="large"
                >
                    <FormattedMessage
                        id="_.modal.fallback_error.refresh"
                        defaultMessage="Refresh"
                    />
                </Button>
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default FallbackErrorModal;
